/**
 * Filtro responsável por abstrair a parte inicial de um array. Após a filtragem,
 * o array vai se comportar como se não possuísse os elementos anteriores ao
 * índice informado.
 */
/*
 * Esta diretiva, em princípio, será utilizada como auxiliar na paginação de resultados
 * de buscas.
 */
angular.module("avlib").filter('startFrom', function() {
    return function(input, start) {
        start = +start; //parse to int
        return input.slice(start);
    }
});